define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		_getExtraCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: nothing to do here
			return null;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if revised is set to default, then set value from target
			var	node = ctx.getNode();
			return (node[this.idRevised] == this.DEFAULT) ? -999.0 : this._gap(node[this.idRevised], this._getOriginalValue(ctx, node[this.idOriginal]));
		}
	});
});